<template>
    <div class="home-view">
        <Topbar />
        <br>
        <br>
        <div class="container-img mt-2 small pb-3">
            <div class="col-md-6 m-auto mt-3">
                <div class="card small" v-if="!this.preRomaneio">
                    <div class="card-header text-white pt-0 pb-0" :style="{ backgroundColor: moduloAtual().color }">
                        Outbound - Pré Expedição
                        <div v-show="carregando" class="spinner-grow">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div class="card-body p-1 text-left">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-12 p-0 mb-1">
                                    <button class="btn btn-sm btn-primary btn-block" @click="continuarPreRomaneio">
                                        Continuar Pré-Romaneio
                                        <em class="fa fa-arrow-right ml-2"></em>
                                    </button>
                                </div>
                                <div class="col-9 p-0 pr-1">
                                <select class="form-control form-control-sm mr-0" id="transportadora">
                                    <option value="">--TRANSPORTADORA--</option>
                                        <option :value="item.transportadora" v-for="(item) in this.transportadoras" :key="item.transportadora">
                                            {{ item.transportadora }}
                                        </option>
                                    </select> 
                                </div>
                                <div class="col-3 p-0">
                                    <button class="btn btn-sm btn-primary btn-block" @click="dialogoCriarRomaneio()">
                                        Criar
                                    </button>
                                </div>
                            </div>
                        </div>  
                    </div>
                </div>

                <div class="card small" v-if="this.preRomaneio">
                    <div class="card-header text-white pt-0 pb-0" :style="{ backgroundColor: moduloAtual().color }">
                        Outbound - Pré Expedição
                        <div v-show="carregando" class="spinner-grow">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div class="card-body p-1 text-left">
                        <div class="container-fluid">
                            <span>TRANSPORTADORA: </span>
                            <span class="bg-warning rounded font-weight-bold pl-1 pr-1 text-white">
                                {{ this.transportadoraReferencia }}
                            </span>
                            <br>
                            <span>Nº PRÉ-ROMANEIO: </span>
                            <span class="bg-warning rounded font-weight-bold pl-1 pr-1 text-white">
                                {{ this.preRomaneio }}
                            </span>
                            <br>
                            <span>USUÁRIO: </span>
                            <span class="bg-light font-weight-bold pl-1 pr-1 text-danger">
                                {{ getUsername() }}
                            </span>
                            <br>
                            <span>DATA: </span>
                            <span class="bg-light font-weight-bold pl-1 pr-1 text-danger">
                                {{ this.dataAbertura }}
                            </span>
                            <br>
                        </div>

                    </div>
                </div>

                <div class="card small mt-1" v-if="this.preRomaneio">
                    <div class="card-body p-1 mt-1">

                        <button class="btn btn-sm btn-primary btn-block mb-1" data-toggle="modal" data-target="#modalAcoes">
                            Ações
                            <em class="fa fa-align-justify ml-2"></em>
                        </button>

                        <InputDefaultApp
                            :key="'preromaneio-' + this.preRomaneio"
                            inputPlaceHolderSufixo="Digite o pedido"
                            titleScan="Escanear pedido"
                            typeInputMode="numeric"
                            @displayScanFunction="biparPedido"
                            :enterKey="(e) => biparPedido(e.target.value)"
                            idInput="pedidoInput"
                            :errorMessage="this.error"/>
                    </div>
                </div>

                <div class="card small mt-1" v-if="this.preRomaneio">
                    <div class="card-header bg-secondary pt-0 pb-0 text-white">
                        <span>NÚMERO PEDIDOS: </span>
                        <span>{{ this.listaPedidos.length }}</span>
                    </div>
                    <div class="card-body p-1 mt-1">
                        <div class="row">
                            <div class="col-12" v-for="(item) in this.listaPedidos" :key="item.numeroPedido">
                                <div class="border mb-1 rounded p-2 text-left" :class="item.volumeExpedido === item.totalVolume ? 'bg-success text-white' : 'bg-warning text-dark'">
                                    <div class="container-fluid">
                                        <div class="row">
                                            <div class="col-10 m-0">
                                                <span class="font-weight-bold">PEDIDO: </span>
                                                <span class="bg-light font-weight-bold rounded pl-1 pr-1 text-dark ml-2">
                                                    {{ item.numeroPedido }}
                                                </span>
                                                <br>
                                                <span class="bg-light font-weight-bold rounded pl-1 pr-1 text-dark">
                                                    {{ item.cliente.nomeFantasia + " - " + item.cliente.idCliente }}
                                                </span>
                                                <br>
                                                <span class="font-weight-bold">VOLUME: </span>
                                                <span class="bg-light font-weight-bold rounded pl-1 pr-1 text-dark ml-2">
                                                    {{ item.volumeExpedido  }} / {{ item.totalVolume }}
                                                </span>
                                            </div>
                                            <div class="col-2 m-0 pt-2">
                                                <button class="btn btn-danger btn-sm m-auto" @click="retirarBipagem(item.id)">
                                                    <em class="fa fa-trash"></em>
                                                </button>
                                            </div>
                                        </div>
                                    </div> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-5 text-center text-secondary" v-if="!this.preRomaneio">
                <em class="fa fa-info-circle fa-3x mb-2"></em>
                <br>
                <span class="small">Selecione uma transportadora para o novo pré-romaneio!</span>
            </div>
        </div>
        
        <LogoutModal />

        <Modal
            id="modalInformarPreRomaneio"
            title="N° Pré-Romaneio"
            :carregando="carregando"
            :confirmFunction="() => buscarPreRomaneio()"
            :cancelFunction="() => closeModal('modalRetorno')"
            cancelText="Cancelar"
            confirmText="Continuar"
        >
            <div class="small text-center">
                <InputDefaultApp
                    :key="'preromaneioInput'"
                    inputPlaceHolderSufixo="Digite o pré-romaneio"
                    titleScan="Escanear pré-romaneio"
                    typeInputMode="numeric"
                    @displayScanFunction="buscarPreRomaneio"
                    :enterKey="(e) => buscarPreRomaneio(e.target.value)"
                    idInput="preromaneioInput"
                    :errorMessage="this.errorBuscarPreRomaneio"/>
            </div>
        </Modal>

        <Modal
            id="modalRetorno"
            title="Sucesso"
            :carregando="carregando"
            :buttonList="[]"
            :cancelFunction="() => closeModal('modalRetorno')"
            cancelText="OK"
        >
            <div class="small text-center">
                <em class="fa fa-check-circle text-success fa-3x"></em>
                <br>
                <br>
                <span>{{ this.retornoMessage }}</span>
            </div>
        </Modal>

        <Modal
            id="modalError"
            title="Aviso"
            :carregando="carregando"
            :buttonList="[]"
            :cancelFunction="() => closeModal('modalError')"
            cancelText="OK"
            :customClass="this.classModal"
        >
            <div class="small text-center">
                <em class="fa fa-info-circle text-warning fa-3x"></em>
                <br>
                <br>
                <span>{{ this.errorMessageModal }}</span>
            </div>
        </Modal>

        <Modal
            id="modalDialogoCriarPreRomaneio"
            title="Confirme"
            :carregando="carregando"
            :confirmFunction="criarPreRomaneio"
            :cancelFunction="() => closeModal('modalDialogoCriarPreRomaneio')"
            confirmText="Sim"
            cancelText="Não"
        >
            <div class="small text-center">
                Deseja criar um novo pré romaneio para a transportadora:  ?
            </div>
        </Modal>

        <Modal
            id="modalBiparProdutos"
            title="Produtos Pedido"
            :carregando="carregando"
            :buttonList="[]"
            :noFooter="true"
            :cancelFunction="() => closeModal('modalBiparProdutos')"
            :disableCloseModal="true"
        >
            <div class="small text-left">
                <div class="container-fluid text-left small mt-0">
                    <div class="row mt-2">
                        <div class="col-12 mt-0">
                            <InputDefaultApp
                                inputPlaceHolderSufixo="código do produto"
                                titleScan="Escanear produto"
                                typeInputMode="text"
                                @displayScanFunction="biparProduto"
                                :enterKey="(e) => biparProduto(e.target.value)"
                                idInput="produtoInput"
                                :errorMessage="this.error"/>
                        </div>
                        <div class="col-12 mt-2">
                            <div class="border rounded bg-white p-1 text-center">
                                Total produtos bipados:
                                <span id="totalItensBipados" class="ml-2">{{ this.totalProdutosBipado }}</span>
                                /
                                <span id="totalItens">{{ this.produtosPedido.length }}</span>
                            </div>
                        </div>
                        <div class="col-12 mt-2">
                            <button class="btn btn-sm btn-warning btn-block" @click="dialogoEnviarParaAnalise">
                                Enviar para análise
                            </button>
                        </div>
                    </div>
                    <table class="table table-bordered mt-2 m-0">
                        <caption class="d-none"></caption>
                        <thead class="small">
                            <th class="pt-1 pb-1">PRODUTOS</th>
                        </thead>
                        <tbody class="d-none">
                        </tbody>
                    </table>
                    <div style="height: 130px; overflow-x: hidden; overflow-y: auto; border: 1px solid #CCC; border-top: 0px;">
                        <table class="table m-0">
                            <caption class="d-none"></caption>
                            <thead class="d-none">
                                <th style="width: 100%">PRODUTO</th>
                            </thead>
                            <tbody id="tbodyProdutos">
                                <tr v-for="(item) in this.produtosPedido" :key="item.id">
                                    <td :class="item.bipado">
                                        {{ item.descricao }}
                                        <br>
                                        <span class="font-weight-bold">Código de barras:</span>
                                        <span class="border bg-warning rounded pl-2 pr-2">
                                            {{ item.codbarras }}
                                        </span>
                                        <br>
                                        <span class="font-weight-bold">SKU:</span>
                                        <span class="border bg-warning  rounded pl-2 pr-2">
                                            {{ item.sku }}
                                        </span>
                                        <hr>
                                        <span class="font-weight-bold">Qtde packing:</span>
                                        <span class="border bg-warning rounded pl-2 pr-2">
                                            {{ item.qtdeconfpacking }}
                                        </span>
                                        <br>
                                        <span class="font-weight-bold">Qtde Pendente:</span>
                                        <span class="border bg-warning rounded pl-2 pr-2">
                                            {{ item.qtdeconfpre }}
                                        </span>
                                        <br>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </Modal>

        <Modal
            id="modalDialogoEnviarParaAnalise"
            title="Confirme"
            :carregando="carregando"
            :confirmFunction="enviarParaAnalise"
            :cancelFunction="() => closeModal('modalDialogoEnviarParaAnalise')"
            confirmText="Sim"
            cancelText="Não"
        >
            <div class="small text-center">
                Deseja enviar o pedido: {{ this.pedidoBipagemProdutos.numeroPedido }} para analise?
            </div>
        </Modal>

        <Modal
            id="modalAcoes"
            title="Ações"
            :buttonList="[]"
            :noFooter="true"
            :cancelFunction="focusBarras"
        >   
            <button class="btn btn-success btn-sm btn-block m-1" @click="concluirPreRomaneio">
                Concluir pré-romaneio
                <em class="fa fa-check-circle ml-2"></em>
           </button>
            <button class="btn btn-info btn-sm btn-block m-1" @click="novaPreExpedicao">
                Criar novo pré-romaneio
                <em class="fa fa-undo ml-2"></em>
           </button>
           
           <button class="btn btn-danger btn-sm btn-block m-1" @click="closeModal('modalAcoes')">
                Sair
                <em class="fa fa-times ml-2"></em>
           </button>
        </Modal>
    </div>
</template>
  
  
<script>
// @ is an alias to /src
import Topbar from '@/components/Topbar.vue'
import LogoutModal from '@/components/LogoutModal.vue'
import ViewMixin from './ViewMixin'
import InputDefaultApp from '../components/InputDefaultApp.vue';
import { DEFAULT_ERROR_MESSAGE, ServerErrorException, TokenInvalidoException } from '../services/exceptions'
import api, { getUserId, getUsername } from '../services/api'
import $ from "jquery";
import audioService from '@/services/audioService.js';
import { dateFormat } from '../utils';
import Modal from "../components/Modal.vue";

export default {
    name: 'PreExpedicao',
    mixins: [
        ViewMixin
    ],
    components: {
        Topbar,
        LogoutModal,
        Modal,
        InputDefaultApp
    },

    data: () => {
        return {
            error: null,
            retornoMessage: null,
            errorMessageModal: null,
            transportadoras: [],
            transportadoraReferencia: null,
            preRomaneio: null,
            dataAbertura: null,
            listaPedidos: [],
            classModal: null,
            errorBuscarPreRomaneio: null,
            produtosPedido: [],
            pedidoBipagemProdutos: {
                pedido: null,
            },
            totalProdutosBipado: 0,
        };
    },

    async mounted() {
        try {
            await this.validarToken();
        } catch (e) {
            if (e instanceof TokenInvalidoException) {
                this.handleTokenInvalidoException();
            } else if (e instanceof ServerErrorException) {
                alert(e.message);
            } else {
                alert(DEFAULT_ERROR_MESSAGE);
            }      
        }

        this.getTransportadoras();
    },

    methods: {
        getUserId,
        getUsername,
        dateFormat,

        showErrorModal(message) {
            this.errorMessageModal = message;
            $("#modalError").modal('show');
        },

        showMessageSuccess(message) {
            this.retornoMessage = message;
            $("#modalRetorno").modal('show');
        },

        playSoundWarning() {
            audioService.playAlarm();
        },

        playSoundSuccess() {
            audioService.success();
        },

        async validarToken() {
            this.carregando = true;
    
            await api.get("/validar-token");
    
            this.carregando = false;
        },

        closeModal(modal) {
            $("#" + modal).modal("hide");
        },

        focusBarras() {
            $("#pedidoInput").focus();
            $("#pedidoInput").select();
        },

        alertaSonoro(message) {
            this.classModal = "bg-danger";
            this.showErrorModal(message);
            audioService.ban();
        },

        novaPreExpedicao() {
            this.closeModal('modalAcoes');

            this.error = null;
            this.retornoMessage = null;
            this.errorMessageModal = null;
            this.transportadoraReferencia = null;
            this.preRomaneio = null;
            this.dataAbertura = null;
            this.listaPedidos = [];
        },

        async getTransportadoras() {
            this.carregando = true;
            try {
                let response = await api.get("/outbound/expedicao/transportadoras");
                this.transportadoras = response.data;

                this.carregando = false;
            } catch (error) {
                this.showErrorModal(error.message);
                this.carregando = false;
                this.classModal = null;
                this.playSoundWarning();
            }
        },

        dialogoCriarRomaneio() {
            let transportadora = $('#transportadora').val();

            if (transportadora.trim() === "") {
                this.playSoundWarning();
                this.classModal = null;
                this.showErrorModal("Selecione a transportadora!");

                return;
            }

            $("#modalDialogoCriarPreRomaneio").modal("show");
        },

        continuarPreRomaneio() {
            $("#modalInformarPreRomaneio").modal("show");
            $("#preromaneioInput").val("");

            setTimeout(() => {
                $("#preromaneioInput").focus();
            }, 500);
        },

        async buscarPreRomaneio(barras=null) {
            
            if (barras === null) {
                barras = $('#preromaneioInput').val();
            }

            if (barras.trim() === "") {
                this.playSoundWarning();
                this.showErrorModal("Informe o número do pré-romaneio!");
                return;
            }

            try {
                let response = await api.post("/outbound/preexpedicao/buscar", {idPreRomaneio: barras});

                this.transportadoraReferencia = response.data.transportadora;
                this.preRomaneio = response.data.idpreromaneiossaida;
                this.dataAbertura = dateFormat(response.data.dataabertura);
                this.listaPedidos = response.data.listaPedidos;

                this.closeModal('modalInformarPreRomaneio');

                setTimeout(() => {
                    this.focusBarras();
                }, 500);

            } catch (error) {
                this.playSoundWarning();
                this.errorBuscarPreRomaneio = error.message;
            }
        },

        async criarPreRomaneio() {
            let transportadora = $('#transportadora').val();
            $("#modalDialogoCriarPreRomaneio").modal("hide");

            try {
                let body = {
                    transportadora: transportadora,
                    idUsuario: getUserId()
                };
                let response = await api.post("/outbound/preexpedicao/criar", body);

                this.transportadoraReferencia = transportadora;
                this.preRomaneio = response.data.idpreromaneiossaida;
                this.dataAbertura = dateFormat(response.data.dataabertura);
                setTimeout(() => {
                    this.focusBarras();
                }, 500);
            } catch (error) {
                this.classModal = null;
                this.showErrorModal(error.message);
                this.playSoundWarning();
            }
        },

        pegaJson(codigo) {
            if (codigo.includes("{\"sorte_code\":\"")) {
                let obj = JSON.parse(codigo);
                return obj.sorte_code;
            }

            let indexOfVirgula = codigo.indexOf(',');
            let trecho = codigo.substr(0, indexOfVirgula);

            let indexOfAspasFinais = trecho.length - 1;
            let aspasFinais = trecho[indexOfAspasFinais];

            let aspasIniciais = -1;
            for(let i = 0; i < trecho.length - 1; i++){
                if(trecho[i] == aspasFinais){
                    aspasIniciais = i;
                }
            }

            let numero = trecho.substring(aspasIniciais + 1, indexOfAspasFinais)
            return numero.replace("/", "-");
        },

        async biparPedido(pedido) {
           
            if (pedido.trim() === "") {
                this.errorBipagem = "Bipe o código de barras do pedido!";
                this.playSoundWarning();
                $("#barrasInput").focus();
                $("#barrasInput").select();
                return;
            }

            let codigobarras = String(pedido).replace('=', '').toLowerCase();
            if(codigobarras.includes("sender") || codigobarras.includes("id") || codigobarras.includes("security")){
                codigobarras = this.pegaJson(codigobarras);
            }

            if (codigobarras.trim() === "") {
                codigobarras = pedido.trim();
            }
                
            this.error = null;
            
            try {
                let body = {
                    idUsuario: getUserId(),
                    idPreRomaneio: this.preRomaneio,
                    transportadora: this.transportadoraReferencia,
                    codigobarras: codigobarras
                };

                let response = await api.post("/outbound/preexpedicao/bipar", body);
                this.updateListaPedidos(response.data);
                this.focusBarras();
            } catch (error) {
                if (error.message.includes("alertaSonoro")) {
                    let errorObj = JSON.parse(error.message);
                    this.alertaSonoro(errorObj.alertaSonoro);
                } else {
                    this.classModal = null;
                    this.playSoundWarning();
                    this.error = error.message;
                    this.focusBarras();
                }
            }
        },

        updateListaPedidos(pedido) {
            
            let existeNalista = false;
            for (let item of this.listaPedidos) {
                if (item.id === pedido.id) {
                    existeNalista = true;
                    item["volumeExpedido"] = pedido.volumeExpedido;
                    if (item.volumeExpedido === item.totalVolume) {
                        this.verificarDefinicaoBiparProduto(pedido);
                    }
                    break;
                }
            }

            if (!existeNalista) {
                if (pedido.volumeExpedido === pedido.totalVolume) {
                    this.verificarDefinicaoBiparProduto(pedido);
                }
                this.listaPedidos.push(pedido);
            }
        },

        async verificarDefinicaoBiparProduto(pedido) {
            try {
                let response = await api.post('/outbound/preexpedicao/verificarskusrelacionados', {
                    idDocumento: pedido.id,
                    cliente: pedido.cliente.idCliente
                });

                if (!JSON.stringify(response.data).includes("erro")) {
                    this.listarProdutos(response.data, pedido);
                } else {
                    this.playSoundSuccess();
                }
            } catch (error) {
                this.error = error.message;
            }
        },

        async listarProdutos(retorno, pedido) {
            this.totalProdutosBipado = 0;
            console.log(retorno);
            $("#produtoInput").val("");

            $("#modalBiparProdutos").modal('show');

            setTimeout(() => {
                $("#produtoInput").focus();
                $("#produtoInput").select();
            }, 1000);

            try {
                let response = await api.post('/outbound/preexpedicao/produtos', {
                    bipe: pedido.id
                });
                this.pedidoBipagemProdutos = pedido;
                this.produtosPedido = response.data;
            } catch (error) {
                this.error = error.message;
            }
        },

        async biparProduto(codigobarras) {
            try {
                let response = await api.post('/outbound/preexpedicao/biparproduto', {
                    idDocumento: this.pedidoBipagemProdutos.id,
                    barras: codigobarras
                });

                this.processarBipagemProduto(codigobarras, response.data);
            } catch (error) {
                this.error = error.message;
                this.playSoundWarning();
            }
        },

        processarBipagemProduto(codigobarras, produtoBipado) {

            for (const item of this.produtosPedido) {
                if (item.codbarras === codigobarras) {
                    item.qtdeconfpre = produtoBipado.bipadoPre;

                    if (item.qtdeconfpacking === item.qtdeconfpre) {
                        this.totalProdutosBipado++;
                        item["bipado"] = "bg-success text-white";
                    }
                }
            }

            if (parseInt(this.totalProdutosBipado) === this.produtosPedido.length) {
                
                this.playSoundSuccess();
                this.error = null;

                setTimeout(() => {
                    $("#modalBiparProdutos").modal('hide');
                    $("#pedidoInput").focus();
                }, 1000);
            }
        },

        dialogoEnviarParaAnalise() {
            $("#modalDialogoEnviarParaAnalise").modal('show');
        },

        async enviarParaAnalise() {
            try {
                let response = await api.post('/outbound/preexpedicao/enviarparaanalise', {
                    idDocumento: this.pedidoBipagemProdutos.id,
                    idUsuario: getUserId()
                });

                if (JSON.stringify(response).includes("idDocumento")) {
                    this.error = null;
                    this.retirarBipagem(this.pedidoBipagemProdutos.id);

                    setTimeout(() => {
                        $("#modalBiparProdutos").modal('hide');
                        $("#modalDialogoEnviarParaAnalise").modal('hide');
                        $("#pedidoInput").focus();
                        this.showMessageSuccess(`Pedido N° ${this.pedidoBipagemProdutos.numeroPedido} enviado para análise com sucesso!`);
                    }, 1000);
                }
            } catch (error) {
                this.error = error.message;
                this.playSoundWarning();
            }
        },

        async retirarBipagem(idDocumento) {
            try {
                let body = {
                    idDocumento: idDocumento
                };

                let respose = await api.post("/outbound/preexpedicao/retirarbipagem", body);

                let newList = [];
                for (let item of this.listaPedidos) {
                    if (respose.data.idDocumento !== item.id) {
                        newList.push(item);
                    }
                }

                this.listaPedidos = newList;
                this.focusBarras();
            } catch (error) {
                this.playSoundWarning();
                this.showErrorModal(error.message);
            }
        },

        async concluirPreRomaneio() {

            this.closeModal('modalAcoes');
            let valid = true;
            
            for (let item of this.listaPedidos) {
                if (parseInt(item.volumeExpedido) !== parseInt(item.totalVolume)) {
                    valid = false;
                    break;
                }
            }

            if (!valid || this.listaPedidos.length === 0) {
                this.showErrorModal("Há pedidos com a bipagem pendente! Não será possível finalizar o pré-romaneio!");
                this.playSoundWarning();
                return;
            }

            try {
                let body = {
                    idPreRomaneio: this.preRomaneio,
                    idUsuario: getUserId()
                };

                let response = await api.post("/outbound/preexpedicao/concluir", body);
                this.showMessageSuccess(`Pré-Romaneio nº ${response.data.idPreRomaneio} concluído com sucesso!`);
                this.closeModal('modalAcoes');

                this.error = null;
                this.errorMessageModal = null;
                this.transportadoraReferencia = null;
                this.preRomaneio = null;
                this.dataAbertura = null;
                this.listaPedidos = [];

            } catch (error) {
                this.playSoundWarning();
                this.showErrorModal(error.message);
            }
        },
    }
}
</script>
  
<style scoped lang="scss">
    .home-view {
        height: 100%;
    }

    .scroll {
        height: 140px;
        overflow-y: auto;
        overflow-x: hidden;
        width: 100%;
    }
</style>
  